<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="modal fade" id="cards-columns" tabindex="-1" aria-hidden="true">
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">{{ $t("cards.cards_columns") }}</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-at"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.username") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.username.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.password") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.password.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="firstname"
                        checked
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-player-pause"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.used") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.used.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.profile") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.profile.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-color-swatch"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.batch") }}
                        </span>
                      </span>
                      <input
                        v-model="columns.batch.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-cancel"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.expires_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.expires_at.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-package"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.used_quota") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.remaining_quota_mb.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber2"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-square-dot"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.used_quota_value") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.used_quota_mb.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="portNumber2"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-progress"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.active.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-network"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.connection") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.online.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="fixed_mac_address"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-network"></i>
                        <span class="custom-option-title">
                          {{ $t("cards.fixed_mac_address") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.fixed_mac_address.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="fixed_mac_address"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CardsEdit
      v-if="showEditCard"
      :selected-card="selectedData"
      @updated="
        showEditCard = false;
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-danger waves-effect waves-light"
                    tabindex="0"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    @click.prevent="cards_truncate"
                  >
                    <span>
                      <i class="ti ti-trash ti-xs me-2"></i>
                      <span class=" ">{{
                        $t("cards.remove_expired_cards")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul
                    class="dropdown-menu"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                  >
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('cards_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="export_csv('cards_table', 'cards')"
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('cards_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    v-model="filters.search_query"
                    @change="applyFilters"
                    class="form-control"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#cards-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="cards_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('cards_delete_cards')">
                            <button
                              @click="groupDelete"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                        id="defaultCheck1"
                      />
                    </th>
                    <th class="sorting" v-if="columns.username.enabled">
                      <div class="sortable" @click="sort('username')">
                        {{ $t("cards.username") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.username.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.username.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.password.enabled">
                      <div class="sortable" @click="sort('password')">
                        {{ $t("cards.password") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.password.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.password.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.used.enabled">
                      {{ $t("cards.used") }}
                    </th>
                    <th class="sorting" v-if="columns.profile.enabled">
                      {{ $t("cards.profile") }}
                    </th>
                    <th class="sorting" v-if="columns.batch.enabled">
                      {{ $t("cards.batch") }}
                    </th>
                    <th class="sorting" v-if="columns.expires_at.enabled">
                      <div class="sortable" @click="sort('expires_at')">
                        {{ $t("cards.expires_at") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.expires_at.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.expires_at.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.remaining_quota_mb.enabled"
                    >
                      {{ $t("cards.used_quota") }}
                    </th>
                    <th class="sorting" v-if="columns.used_quota_mb.enabled">
                      {{ $t("cards.used_quota_value") }}
                    </th>
                    <th class="sorting" v-if="columns.active.enabled">
                      {{ $t("cards.status") }}
                    </th>
                    <th class="sorting" v-if="columns.online.enabled">
                      {{ $t("cards.connection") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.fixed_mac_address.enabled"
                    >
                      {{ $t("cards.fixed_mac_address") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('cards_view_search_cards')">
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.username.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.username"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.password.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.password"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.used.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <div style="width: 100px;">
                        <select
                          @change="applyFilters"
                          v-model="filters.used"
                          class="form-select w-100"
                          data-style="btn-default"
                        >
                          <option
                            v-for="ft in [
                              { id: '', name: $t('control.filter') },
                              { id: '1', name: $t('control.yes') },
                              { id: '0', name: $t('control.no') },
                            ]"
                            v-bind:key="ft.id"
                            :value="ft.id"
                          >
                            {{ ft.name }}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th v-if="columns.profile.enabled"></th>
                    <th v-if="columns.batch.enabled"></th>
                    <th
                      v-if="columns.expires_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.expires_at"
                        type="datetime-local"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        id="flatpickr-datetime"
                      />
                    </th>
                    <th v-if="columns.remaining_quota_mb.enabled"></th>
                    <th v-if="columns.used_quota_mb.enabled"></th>
                    <th
                      v-if="columns.active.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <div style="width: 150px;">
                        <select
                          @change="applyFilters"
                          v-model="filters.active"
                          class="form-select w-100"
                          data-style="btn-default"
                        >
                          <option
                            v-for="ft in [
                              { id: '', name: $t('control.all') },
                              { id: 'active', name: $t('control.active') },
                              { id: 'expired', name: $t('control.expired') },
                              { id: 'expiring', name: $t('control.expiring') },
                              { id: 'disabled', name: $t('control.disabled') },
                            ]"
                            v-bind:key="ft.id"
                            :value="ft.id"
                          >
                            {{ ft.name }}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th
                      v-if="columns.online.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <div style="width: 100px;">
                        <select
                          @change="applyFilters"
                          v-model="filters.online"
                          class="form-select w-100"
                          data-style="btn-default"
                        >
                          <option
                            v-for="ft in [
                              { id: '', name: $t('control.all') },
                              { id: 'online', name: $t('control.online') },
                              { id: 'offline', name: $t('control.offline') },
                            ]"
                            v-bind:key="ft.id"
                            :value="ft.id"
                          >
                            {{ ft.name }}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th v-if="columns.fixed_mac_address.enabled"></th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(card, index) in dataList" :key="card.id">
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('cards_edit_card')">
                            <button
                              @click="showEditCardDialog(card)"
                              class="dropdown-item text-primary"
                              href="#"
                            >
                              <i class="ti ti-pencil me-2"></i
                              >{{ $t("actions.edit") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              hasPrivilege('cards_edit_cards') &&
                                user.type != 'reseller'
                            "
                          >
                            <button
                              @click="clearData(card)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-eraser me-2"></i
                              >{{ $t("actions.clear") }}
                            </button>
                          </li>

                          <li>
                            <button
                              @click="
                                this.$router.push(
                                  `/sessions?username=${card.username}`,
                                )
                              "
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view_sessions") }}
                            </button>
                          </li>

                          <li v-if="hasPrivilege('cards_disconnect_cards')">
                            <button
                              @click="disconnectData(card)"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-wifi-off me-2"></i
                              >{{ $t("actions.disconnect") }}
                            </button>
                          </li>

                          <li
                            v-if="
                              hasPrivilege('cards_disable_cards') &&
                                card.enabled
                            "
                          >
                            <button
                              @click="disableData(card)"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disable") }}
                            </button>
                          </li>

                          <li
                            v-if="
                              hasPrivilege('cards_disable_cards') &&
                                !card.enabled
                            "
                          >
                            <button
                              @click="enableData(card)"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-shield me-2"></i
                              >{{ $t("actions.enable") }}
                            </button>
                          </li>

                          <li v-if="hasPrivilege('cards_delete_cards')">
                            <button
                              @click="deleteData(card)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="card.selected"
                        @click="selectData(card)"
                      />
                    </td>
                    <td v-if="columns.username.enabled" dir="ltr">
                      {{ card.username }}
                    </td>
                    <td v-if="columns.password.enabled">
                      <div v-if="hasPrivilege('cards_view_cards_passwords')">
                        {{ card.password }}
                      </div>
                    </td>
                    <td v-if="columns.used.enabled">
                      <span
                        v-if="!card.used"
                        class="badge bg-label-success me-1"
                        >{{ $t("control.no") }}</span
                      >
                      <span
                        v-if="card.used"
                        class="badge bg-label-danger me-1"
                        >{{ $t("control.yes") }}</span
                      >
                    </td>
                    <td v-if="columns.profile.enabled" scope="row">
                      {{ card.profile.name }}
                    </td>
                    <td v-if="columns.batch.enabled">{{ card.batch.name }}</td>
                    <td v-if="columns.expires_at.enabled">
                      <div v-if="card.expires_at">
                        {{ formatDate(card.expires_at) }}
                      </div>
                      <div v-if="!card.expires_at"></div>
                    </td>
                    <td v-if="columns.remaining_quota_mb.enabled">
                      <div
                        v-if="
                          card.profile.traffic_limited &&
                            hasPrivilege('cards_view_cards_quota')
                        "
                      >
                        <div
                          class="progress relative"
                          style="height: 25px;width: 180px;"
                        >
                          <div
                            class="progress-bar"
                            role="progressbar"
                            :style="{
                              width: `${parseFloat(
                                (card.used_quota_mb * 100) /
                                  card.allowed_quota_mb,
                              ).toFixed(0)}%`,
                            }"
                            :class="{
                              'bg-success':
                                card.used_quota_mb / card.allowed_quota_mb <=
                                  1 / 2 &&
                                card.used_quota_mb / card.allowed_quota_mb <
                                  2 / 3,
                              'bg-warning':
                                card.used_quota_mb / card.allowed_quota_mb >=
                                  2 / 3 &&
                                card.used_quota_mb / card.allowed_quota_mb < 1,
                              'bg-danger':
                                card.used_quota_mb / card.allowed_quota_mb >= 1,
                            }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {{
                              parseFloat(
                                (card.used_quota_mb * 100) /
                                  card.allowed_quota_mb,
                              ).toFixed(0)
                            }}%
                          </div>
                          <div
                            v-if="
                              (card.used_quota_mb * 100) /
                                card.allowed_quota_mb <
                                5
                            "
                            class="d-flex align-items-center justify-center text-center w-100"
                          >
                            {{
                              parseFloat(
                                (card.used_quota_mb * 100) /
                                  card.allowed_quota_mb,
                              ).toFixed(0)
                            }}%
                          </div>
                        </div>
                      </div>
                      <div v-if="!card.profile.traffic_limited">
                        {{ $t("control.unlimited") }}
                      </div>
                    </td>
                    <td v-if="columns.used_quota_mb.enabled">
                      <span
                        class="badge bg-label-info mb-2 me-1"
                        v-if="card.used_quota_mb !== ''"
                        >{{
                          card.used_quota_mb >= 1024
                            ? parseFloat(card.used_quota_mb / 1024).toFixed(2) +
                              " GB"
                            : card.used_quota_mb + " MB"
                        }}</span
                      >
                    </td>
                    <td v-if="columns.active.enabled">
                      <div v-if="hasPrivilege('cards_view_cards_status')">
                        <span
                          v-if="card.active && card.enabled"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.active") }}</span
                        >
                        <span
                          v-if="!card.active && card.enabled"
                          class="badge bg-label-warning me-1"
                          >{{ $t("control.expired") }}</span
                        >
                        <span
                          v-if="!card.enabled"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.disabled") }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.online.enabled">
                      <div v-if="hasPrivilege('cards_view_cards_status')">
                        <span
                          v-if="card.online"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.online") }}</span
                        >
                        <span
                          v-if="!card.online"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.offline") }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.fixed_mac_address.enabled">
                      <div v-if="hasPrivilege('cards_view_cards_status')">
                        {{ card.mac_address }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import CardsEdit from "../components/modals/cards-edit.vue";
export default {
  name: "Cards",
  computed: {
    ...mapGetters(["user"]),
  },
  components: {
    CardsEdit,
  },
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDisconnect: false,
      showDisable: false,
      showEnable: false,
      showClear: false,
      showDeleteAll: false,
      showEditCard: false,
      showContext: false,
      loading: true,
      loading_overlay: false,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        username: "",
        password: "",
        used: "",
        expires_at: "",
        profile: "",
        batch: "",
        remaining_quota_mb: "",
        active: "",
        online: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        username: {
          name: this.$t("cards.username"),
          enabled: true,
          sort: false,
        },
        password: {
          name: this.$t("cards.password"),
          enabled: false,
          sort: false,
        },
        used: { name: this.$t("cards.used"), enabled: true, sort: false },
        expires_at: {
          name: this.$t("cards.expires_at"),
          enabled: false,
          sort: false,
        },
        profile: {
          name: this.$t("cards.profile"),
          enabled: false,
          sort: false,
        },
        batch: { name: this.$t("cards.batch"), enabled: false, sort: false },
        remaining_quota_mb: {
          name: this.$t("cards.used_quota"),
          enabled: true,
          sort: false,
        },
        used_quota_mb: {
          name: this.$t("cards.used_quota_value"),
          enabled: true,
          sort: false,
        },
        active: { name: this.$t("cards.status"), enabled: true, sort: false },
        online: {
          name: this.$t("cards.connection"),
          enabled: true,
          sort: false,
        },
        fixed_mac_address: {
          name: this.$t("cards.fixed_mac_address"),
          enabled: true,
          sort: false,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      showTruncate: false,
      truncateFailed: false,
      debounce_counter: 0,
    };
  },
  async created() {
    this.prepareFilters();
    this.prepareColumns();
    if (this.$route.query.type) {
      switch (this.$route.query.type) {
        case "online":
          this.filters.online = "online";
          break;
        case "expired":
          this.filters.active = "expired";
          break;
        case "disabled":
          this.filters.active = "disabled";
          break;
        case "expiring":
          this.filters.active = "expiring";
          break;
      }
    }
    if (this.$route.query.username) {
      this.filters.username = this.$route.query.username;
      this.columns.enabled = true;
    }
    if (this.$route.query.card_id) {
      this.showEditCardDialog({ id: this.$route.query.card_id });
    }
    this.applyFilters();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      if (this.$route.params.id != null)
        var response = await axios.get(`cards/${this.$route.params.id}/cards`);
      else var response = await axios.get(`cards/cards`);
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    prepareFilters() {
      var filters = localStorage.getItem("cards_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    async showEditCardDialog(card) {
      this.selectedData = card;
      this.showEditCard = true;
      if (card) {
        this.$router.push({
          query: { card_id: card.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("edit-cards");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showEditCard = false;
        this.selectedData = null;
      });
      modalInstance.show();
    },
    prepareColumns() {
      var cols = localStorage.getItem("cards_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          username: {
            name: this.$t("cards.username"),
            enabled: cols[0].enabled,
            sort: false,
          },
          password: {
            name: this.$t("cards.password"),
            enabled: cols[1].enabled,
            sort: false,
          },
          used: {
            name: this.$t("cards.used"),
            enabled: cols[2].enabled,
            sort: false,
          },
          expires_at: {
            name: this.$t("cards.expires_at"),
            enabled: cols[3].enabled,
            sort: false,
          },
          profile: {
            name: this.$t("cards.profile"),
            enabled: cols[4].enabled,
            sort: false,
          },
          batch: {
            name: this.$t("cards.batch"),
            enabled: cols[5].enabled,
            sort: false,
          },
          remaining_quota_mb: {
            name: this.$t("cards.used_quota"),
            enabled: cols[6].enabled,
            sort: false,
          },
          used_quota_mb: {
            name: this.$t("cards.used_quota_value"),
            enabled: cols[7].enabled,
            sort: false,
          },
          active: {
            name: this.$t("cards.status"),
            enabled: cols[8].enabled,
            sort: false,
          },
          online: {
            name: this.$t("cards.connection"),
            enabled: cols[9] != null ? cols[9].enabled : false,
            sort: false,
          },
          fixed_mac_address: {
            name: this.$t("cards.fixed_mac_address"),
            enabled: cols[10] != null ? cols[10].enabled : false,
            sort: false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      if (this.$route.params.id != null)
        var requestString = `cards/${this.$route.params.id}/cards?filter=1`;
      else var requestString = `cards/cards?filter=1`;
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.username != "")
        requestString += `&username=${this.filters.username}`;
      if (this.filters.password != "")
        requestString += `&password=${this.filters.password}`;
      if (this.filters.expires_at != "")
        requestString += `&expires_at=${this.filters.expires_at}`;
      if (this.filters.opened != "")
        requestString += `&opened=${this.filters.used}`;
      if (this.filters.active != "")
        requestString += `&active=${this.filters.active}`;
      if (this.filters.online != "")
        requestString += `&online=${this.filters.online}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      if (this.debounce != null) {
        this.debounce_counter++;
      } else {
        this.debounce_counter--;
      }
      var local_debounce_location = this.debounce_counter;
      const response = await axios.get(requestString);
      if (this.debounce_counter == local_debounce_location) {
        this.dataList = Object.values(response.data.data);
        if (this.filters.save)
          localStorage.setItem("cards_filters", JSON.stringify(this.filters));
        if (this.dataList.length < 1 && this.filters.page != 1) {
          this.filters.page = 1;
          this.applyFilters();
        }
        if (this.sort_col) {
          if (this.sort_dir == "ASC") {
            this.dataList.sort((a, b) =>
              a[this.sort_col] > b[this.sort_col]
                ? 1
                : b[this.sort_col] > a[this.sort_col]
                ? -1
                : 0,
            );
          } else {
            this.dataList.sort((a, b) =>
              a[this.sort_col] < b[this.sort_col]
                ? 1
                : b[this.sort_col] < a[this.sort_col]
                ? -1
                : 0,
            );
          }
        }
        clearTimeout(this.debounce);
        this.meta = response.data.meta;
        this.loading = false;
      }
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   if (this.debounce_counter == local_debounce_location) {
      //     this.dataList = Object.values(response.data.data);
      //     if (this.filters.save)
      //       localStorage.setItem("cards_filters", JSON.stringify(this.filters));
      //     if (this.dataList.length < 1 && this.filters.page != 1) {
      //       this.filters.page = 1;
      //       this.applyFilters();
      //     }
      //     if (this.sort_col) {
      //       if (this.sort_dir == "ASC") {
      //         this.dataList.sort((a, b) =>
      //           a[this.sort_col] > b[this.sort_col]
      //             ? 1
      //             : b[this.sort_col] > a[this.sort_col]
      //             ? -1
      //             : 0
      //         );
      //       } else {
      //         this.dataList.sort((a, b) =>
      //           a[this.sort_col] < b[this.sort_col]
      //             ? 1
      //             : b[this.sort_col] < a[this.sort_col]
      //             ? -1
      //             : 0
      //         );
      //       }
      //     }
      //     clearTimeout(this.debounce);
      //     this.meta = response.data.meta;
      //     this.loading = false;
      //   }
      // }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    editData(selectedData) {
      this.$router.push(
        `/cards/${this.$route.params.id}/cards/${selectedData.id}/edit`,
      );
    },
    async deleteData(card) {
      this.$swal({
        title: this.$t("messages.cards.delete") + " " + card.username,
        text: this.$t("cards.this_will_delete_all_expired_cards_from_system"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("cards.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`/cards/${card.id}/card`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.deleted_card"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async cards_truncate() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("cards.this_will_delete_selected_card_from_system"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("cards.yes_delete_cards"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post("cards/truncate");
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.removed_expired_cards"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDelete() {
      this.$swal({
        title: this.$t("messages.cards.delete_all"),
        text: this.$t("cards.this_will_delete_all_selected_cards_from_system"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("cards.yes_delete_cards"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`cards/group`, {
              cards: this.selection_array,
            });
            if (response.status == 200) {
              this.applyFilters();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.deleted_cards"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async disableData(card) {
      this.$swal({
        title: this.$t("messages.cards.disable") + " " + card.username,
        text: this.$t(
          "cards.this_will_disable_card_and_prevent_it_from_using_internet",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`cards/${card.id}/disable`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.card_disabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async enableData(card) {
      this.$swal({
        title: this.$t("messages.cards.enable") + " " + card.username,
        text: this.$t(
          "cards.this_will_enable_card_and_return_it_to_using_internet",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-success",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`cards/${card.id}/disable`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.card_enabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async disconnectData(card) {
      this.$swal({
        title: this.$t("messages.cards.disconnect") + " " + card.username,
        text: this.$t("cards.this_will_disconnect_card_from_internet"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`cards/${card.id}/disconnect`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.card_disconnected"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async clearData(card) {
      this.$swal({
        title: this.$t("messages.cards.clear") + " " + card.username,
        text: this.$t("cards.this_will_delete_all_card_sessions"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`cards/${card.id}/clear`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("cards.card_session_cleared"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    openContextMenu(e, card) {
      this.selectedData = card;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns() {
      localStorage.setItem(
        "cards_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    percentColor(card) {
      var percent = parseFloat(
        (card.used_quota_mb * 100) / card.allowed_quota_mb,
      ).toFixed(0);
      if (percent > 0 && percent <= 49) return "#009BFF";
      else if (percent > 49 && percent <= 74) return "#fcba35";
      else if (percent > 74 && percent < 100) return "#ff2626";
      else return "#000000";
    },
    sort(param) {
      this.sort_col = param;
      if (this.columns[param].sort == false) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = 1;
      } else if (this.columns[param].sort === 1) {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = -1;
      } else {
        this.sort_col = null;
        this.sort_dir = null;
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    exportCsv(id) {
      window.location.href =
        localStorage.getItem("server_api") + `export/${id}`;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("cards_filters", JSON.stringify(this.filters));
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
<style scoped>
.sortable {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sortable:hover .arrow-up,
.sortable:hover .arrow-down {
  color: #ccc; /* Slightly darker on hover */
}

.column-title {
  text-transform: uppercase;
  color: #333; /* Dark text color */
}

.sort-arrows {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.arrow-up,
.arrow-down {
  display: block;
  line-height: 1;
  color: transparent; /* Default gray color for inactive arrows */
  transition: color 0.2s ease;
}

.sortable[data-sort="asc"] .arrow-up {
  color: #666; /* Darker color for active ascending arrow */
}

.sortable[data-sort="desc"] .arrow-down {
  color: #666; /* Darker color for active descending arrow */
}
</style>
